export const userFields = [
  { id: 'sno', label: 'S.No.', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'user_type', label: 'User Type', alignRight: false },
  { id: 'registration_step', label: 'Register Step', alignRight: false },
  { id: 'url_username', label: 'URL/Username', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'actions', label: '', alignRight: false },
];

export const productFields = [
  { id: 'sno', label: 'S.No.', alignRight: false },
  { id: 'pictures', label: 'Picture', alignRight: false },
  { id: 'title', label: 'Name', alignRight: false },
  {
    id: 'category_data.name',
    label: 'Category',
    alignRight: false,
    nested: true,
  },
  { id: 'price', label: 'Price', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  {id: 'action', label:'Action',  alignRight:false},
];

export const autosuggestFields = [
  { id: 'auto_suggestion_id', label: 'ID', alignRight: false },
  { id: 'pictures', label: 'Picture', alignRight: false },
  { id: 'title', label: 'Name', alignRight: false },
  { id: 'brand', label: 'Brand', alignRight: false },
  { id: 'description', label: 'Description', alignRight: false },
  {
    id: 'category_data.name',
    label: 'Category',
    alignRight: false,
    nested: true,
  },
  { id: 'price', label: 'Price', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  {
    id: 'actions',
    label: '',
    alignRight: false,
  },
];

export const tagFields = [
  { id: 'sno', label: 'S.No.', alignRight: false },
  { id: 'store', label: 'Store', alignRight: false },
  { id: 'value', label: 'Tag Value', alignRight: false },
  {
    id: 'actions',
    label: '',
    alignRight: false,
  },
];

export const categoryFields = [
  { id: 'sno', label: 'S.No.', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'icon', label: 'Icon', alignRight: false },
  { id: 'description', label: 'Description', alignRight: false },
  // { id: 'expert', label: 'Expert', alignRight: false },
  { id: 'tag', label: 'Tag', alignRight: false },
  { id: 'visibility', label: 'Visibility', alignRight: false },
  {
    id: 'actions',
    label: '',
    alignRight: false,
  },
];

export const ProductSpecsOptions = [
  { value: 'tldr', label: 'TL;DR' },
  { value: 'good', label: 'The good' },
  { value: 'bad', label: 'The bad' },
  { value: 'tip', label: 'Pro tips' },
  { value: 'spec', label: 'Specs' },
];

export const ProductProviderOptions = [
  { value: 'amazon', label: 'Amazon' },
  { value: 'target', label: 'Target' },
  { value: 'buybuybaby', label: 'BuyBuyBaby' },
  { value: 'nordstrom', label: 'Nordstrom' },
  { value: 'walmart', label: 'Walmart' },
  { value: 'nunababy', label: 'Nuna' },
  { value: 'uppababy', label: 'Uppababy' },
  { value: 'babybjorn', label: 'BabyBjorn' },
  { value: 'etsy', label: 'Etsy' },
  { value: 'happiestbaby', label: 'HappiestBaby' },
  { value: 'lalo', label: 'Lalo' },
  { value: 'potterybarnkids', label: 'Pottery Barn Kids' },
  { value: 'crateandbarrel', label: 'Crate & Kids' },
  { value: 'other', label: 'Others' },
];

export const logsFields = [
  { id: 'sno', label: 'S.No.', alignRight: false },
  { id: 'method', label: 'Method', alignRight: false },
  { id: 'url', label: 'URL', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'body', label: 'Body', alignRight: false },
  { id: 'data', label: 'Data', alignRight: false },
  { id: 'created_at', label: 'Created At', alignRight: false },
  { id: 'email', label: 'User email', alignRight: false },
];

export const categoryColumns = [
  { id: 'sno', label: 'S.no' },
  { id: 'category', label: 'Category' },
  { id: 'actions', label: 'Actions' },
];

export const questionColumns = [
  { id: 'sno', label: 'S.no' },
  { id: 'question', label: 'Question' },
  { id: 'category', label: 'Category' },
  { id: 'questionNo', label: 'Question No.' },
  { id: 'questionType', label: 'Question Type' },
  { id: 'actions', label: 'Actions' },
];

export const questionTypeOptions = [
  { value: 'single_choice', label: 'Single Choice' },
  { value: 'single_line_textbox', label: 'Single-line Textbox' },
  { value: 'multi_line_textbox', label: 'Multi-line Textbox' },
  { value: 'choice_with_other', label: 'Choice with Other' },
  { value: 'url_input', label: 'URL Input' },
];
